export var EduStage;
(function (EduStage) {
    EduStage["PreSchool"] = "fsk";
    EduStage["LowGrades"] = "ak-f-3";
    EduStage["MiddleGrades"] = "ak-4-6";
    EduStage["HighGrades"] = "ak-7-9";
    EduStage["HighSchool"] = "gy";
    EduStage["Adult"] = "vux";
})(EduStage || (EduStage = {}));
export var ThemeMediaSize;
(function (ThemeMediaSize) {
    ThemeMediaSize[ThemeMediaSize["XSmall"] = 10] = "XSmall";
    ThemeMediaSize[ThemeMediaSize["Small"] = 20] = "Small";
    ThemeMediaSize[ThemeMediaSize["MediumSmall"] = 25] = "MediumSmall";
    ThemeMediaSize[ThemeMediaSize["Medium"] = 30] = "Medium";
    ThemeMediaSize[ThemeMediaSize["MediumLarge"] = 40] = "MediumLarge";
    ThemeMediaSize[ThemeMediaSize["Large"] = 50] = "Large";
    ThemeMediaSize[ThemeMediaSize["XLarge"] = 60] = "XLarge";
})(ThemeMediaSize || (ThemeMediaSize = {}));
export var DigitalCourses;
(function (DigitalCourses) {
    let LdCourseStatus;
    (function (LdCourseStatus) {
        LdCourseStatus["NotStarted"] = "not_started";
        LdCourseStatus["InProgress"] = "in_progress";
        LdCourseStatus["Completed"] = "completed";
    })(LdCourseStatus = DigitalCourses.LdCourseStatus || (DigitalCourses.LdCourseStatus = {}));
})(DigitalCourses || (DigitalCourses = {}));
